import { ReactNode } from 'react';

type Props = {
  className?: string;
  children?: ReactNode;
};
const Bonus = ({ className = '', children }: Props) => (
  <span
    className={`inline-block bg-[#FFE920] rounded-sm py-0.5 px-2 text-sm ${className}`}
  >
    {children}
  </span>
);

export default Bonus;
